const pageContentCache = new Map<string, string>();

export default class WishlistHead extends HTMLElement {
  private wishlistMain: HTMLElement | null = null;
  private pollIntervalId: ReturnType<typeof setInterval> | null = null;
  private wishlistCount: number | null = null;

  connectedCallback(): void {
    this.pollForWishlistPage();
  }

  disconnectedCallback(): void {
    this.stopPolling();
  }

  private pollForWishlistPage(): void {
    this.stopPolling();

    this.pollIntervalId = setInterval(() => {
      const wishlistPage = document.body.querySelector('wishlist-page') as HTMLElement;

      if (!wishlistPage) {
        return;
      }

      this.wishlistMain = wishlistPage;

      this.stopPolling();
    }, 1000);
  }

  private stopPolling(): void {
    if (this.pollIntervalId === null) {
      return;
    }

    clearInterval(this.pollIntervalId);
    this.pollIntervalId = null;
  }
}

customElements.define('wishlist-head', WishlistHead);
